import { success, error, warn } from 'styles/colorProvider';

export const formatBilletStatus = (status) => {
    if (status === 'paid') return { label: 'Pago', color: success };
    if (status === 'due') return { label: 'Vencido', color: error };
    if (status === 'open') return { label: 'Aberto', color: warn };
};
